import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerLibroGiornaleModalComponent } from './worker-libro-giornale-modal';

export const WorkerLibroGiornaleModalModule: string = ng
    .module('worker-libro-giornale-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerLibroGiornaleModalComponent', WorkerLibroGiornaleModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-libro-giornale-modal/worker-libro-giornale-modal.module.ts